import { render, staticRenderFns } from "./ProfileSidebarComponent.vue?vue&type=template&id=0be6b47e"
import script from "./ProfileSidebarComponent.vue?vue&type=script&lang=js"
export * from "./ProfileSidebarComponent.vue?vue&type=script&lang=js"
import style0 from "./ProfileSidebarComponent.vue?vue&type=style&index=0&id=0be6b47e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports